module.exports = __webpack_public_path__ + "media/עגלה.3b972165.mp3";